import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileOccupation",
  props: {
    twoData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    occupationList: function occupationList() {
      return this.twoData || [];
    },
    occupationGroups: function occupationGroups() {
      var list = this.twoData || [];
      var groups = [];
      for (var i = 0; i < list.length; i += 4) {
        groups.push(list.slice(i, i + 4));
      }
      return groups;
    },
    cssVars: function cssVars() {
      return {
        "--mocc-spacing": "16px",
        "--mocc-radius": "12px",
        "--mocc-font-base": "14px",
        "--mocc-title-color": "#133583",
        "--mocc-desc-color": "#90A1C7",
        "--mocc-primary": "#1668f4",
        "--mocc-padding-top": "20px",
        "--mocc-section-title-font-size": "18px",
        "--mocc-section-title-mb": "12px",
        "--mocc-section-more-font-size": "13px",
        "--mocc-item-height": "90px",
        "--mocc-item-mr": "10px",
        "--mocc-name-padding-x": "12px"
      };
    }
  },
  methods: {
    getJobBg: function getJobBg(index) {
      var n = index % 8 + 1;
      try {
        return require("@/assets/home_phone/job_".concat(n, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      this.$router.push({
        path: "/virtual",
        query: {
          id: item.id,
          occupationCategory: item.name,
          courseType: "14"
        }
      });
    },
    goMore: function goMore() {
      this.$router.push("/allModule");
    }
  }
};